/* eslint-disable import/prefer-default-export */
import EntryActionTypes from '../../constants/EntryActionTypes';

export const onFetchDashboard = () => ({
  type: EntryActionTypes.FETCH_DASHBOARD,
  payload: {},
});

export const createComponent = (type, data) => ({
  type: EntryActionTypes.COMPONENT_CREATE,
  payload: {
    type,
    data,
  },
});

export const updateComponent = (type, id, data) => ({
  type: EntryActionTypes.COMPONENT_UPDATE,
  payload: {
    type,
    id,
    data,
  },
});

export const deleteComponent = (id) => ({
  type: EntryActionTypes.COMPONENT_DELETE,
  payload: {
    id,
  },
});
